import {
  Component,
  Input,
  OnDestroy,
  ElementRef,
  ViewChild,
  AfterViewInit,
  NgZone,
} from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import QRCode from 'qrcode';
import { Subscription } from 'rxjs';
import { QRCodeService } from 'src/app/common/services/qr-code.service';
import { QR_LOADER, MODAL_CLOSE_RED, INFO_YELLOW, DN_GRAB_PAY, DN_TNG, DN_BOOST, DN_MAYBANK, DN_SHOPEE_PAY, DN_ALL } from 'src/defaultImages.js';

@Component({
  selector: 'app-payment-qr',
  templateUrl: './payment-qr.component.html',
  styleUrls: ['./payment-qr.component.css'],
})
export class PaymentQRComponent implements AfterViewInit, OnDestroy {
  @ViewChild('qrCodeCanvas', { static: false }) qrCodeCanvas: ElementRef;
  @Input() qrData;
  private qrDataSubscription: Subscription;
  @Input() title;
  @Input() customCloseIcon;
  @Input() regenerateQrHandler: () => void;

  images = {
    QR_LOADER: QR_LOADER,
    MODAL_CLOSE_RED: MODAL_CLOSE_RED,
    INFO_YELLOW: INFO_YELLOW,
    DN_ALL: DN_ALL,
  };
  dnImages = [
    { img: DN_GRAB_PAY, class: 'dn-grab-pay' },
    { img: DN_TNG, class: 'dn-tng' },
    { img: DN_BOOST, class: 'dn-boost' },
    { img: DN_MAYBANK, class: 'dn-maybank' },
    { img: DN_SHOPEE_PAY, class: 'dn-shopee-pay' },
  ];
  viewMore: boolean = false;
  howToScan = [
    {
      title: 'Launch',
      description: 'Ask the customer to launch their preferred Mobile Banking or eWallet app.',
    },
    {
      title: 'Scan',
      description: `Scan the QR displayed on the screen.`,
    },
    {
      title: 'Pay',
      description: 'Confirm the details and make the payment.',
    },
  ];
  constructor(
    private _qrCodeService: QRCodeService,
    private modalRef: NzModalRef,
    private _ngZone: NgZone,

  ) {}

  ngAfterViewInit(): void {
    // Subscribe to changes in qrData property from the QRCodeService
    this.qrDataSubscription = this._qrCodeService.qrData$.subscribe(
      (qrData) => {
        this.qrData = qrData;
        if (this.qrData) {
          this.populateCanvas(this.qrData);
        } else {
          this.resetCanvas();
        }
      }
    );

    this.populateCanvas(this.qrData);
  }

  resetCanvas(): void {
    const canvas = this.qrCodeCanvas.nativeElement;
    const context = canvas.getContext('2d');
    context.clearRect('', 0, 0, 0, 0);
  }

  populateCanvas(qrData): void {
    QRCode.toCanvas(this.qrCodeCanvas.nativeElement, qrData, (error) => {
      if (error) {
        console.error('Error generating QR code:', error);
      }
    });
  }

  closeModal() {
    this.modalRef.close();
  }

  ngOnDestroy(): void {
    // Unsubscribe from the subscription when the component is destroyed
    this.qrDataSubscription.unsubscribe();
  }

  regenerateQrFunc(): void {
    this.regenerateQrHandler();
  }

  updateViewMore(): void {
    this.viewMore = !this.viewMore;
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        try {
          let el: HTMLElement;
          el = document.getElementById('dn-all');
          this._ngZone.run(() => {
            if (el)
              el.scrollIntoView({
                behavior: 'smooth',
              });
          });
        } catch (error) {}
      }, 300);
    });
  }
}
